module.exports = __webpack_public_path__ + "static/360ed-a75dd6a8352dcab7e8eb28b0cc295376.png";